import type { BetSlipState } from '../types';

const promotionPickerToggled = (state: BetSlipState, payload?: string): BetSlipState => ({
  ...state,
  selectedPromotionPicker: payload
});

export default promotionPickerToggled;
